import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware from "redux-thunk";
import Api from "services/api";

const api = new Api();

// eslint-disable-next-line
const reducers = require("reducers").default;

const store = (
  (process.env.NODE_ENV === "development") ?
    createStore(reducers, composeWithDevTools(applyMiddleware(
      thunkMiddleware.withExtraArgument(api))))
    :
    createStore(reducers, applyMiddleware(
      thunkMiddleware.withExtraArgument(api)))
);

// eslint-disable-next-line
export default store;
